// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"4ccfb5a4","845":"922b2a84"}[chunkId] + ".chunk.js";
};